import { Link } from 'react-router-dom';

import {
  getDateWithTimeZone,
  getTimeWithTimeZone
} from '@/helpers/dateHelpers';
import { getUserInitials } from '@/helpers/stringHelpers';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardContent } from '@/components/ui/card';

import { useSelfClientBookingPage } from '@/data/booking';

const UpcomingClientBookings = () => {
  const clientBookings = useSelfClientBookingPage();

  const bookings = clientBookings.data.upcomingBookings.map(
    (bookingId) => clientBookings.data.bookings[bookingId]
  );

  return (
    <ScrollArea className="w-full whitespace-nowrap">
      <div className="flex w-max space-x-2 p-0">
        {bookings.map((booking) => (
          <Card key={booking.id} className="w-[130px]" asChild>
            <Link to={`/booking/${booking.id}/client`}>
              <CardContent className="flex items-center justify-between p-2">
                <Avatar className="h-12 w-12">
                  <AvatarImage
                    src={`/avatars/${booking.coachId}.jpg`}
                    alt={booking.coach?.user?.firstname}
                  />
                  <AvatarFallback>
                    {getUserInitials(booking.coach?.user)}
                  </AvatarFallback>
                </Avatar>
                <div className="text-right">
                  <div className="text-sm font-medium">
                    {getDateWithTimeZone(
                      booking.startDateTime,
                      booking.timeZone,
                      'MM/dd'
                    )}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {getTimeWithTimeZone(
                      booking.startDateTime,
                      booking.timeZone
                    )}
                  </div>
                </div>
              </CardContent>
            </Link>
          </Card>
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
};

export default UpcomingClientBookings;
